import { render, staticRenderFns } from "./adminList.vue?vue&type=template&id=1ff33520"
import script from "./adminList.vue?vue&type=script&lang=js"
export * from "./adminList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ff33520')) {
      api.createRecord('1ff33520', component.options)
    } else {
      api.reload('1ff33520', component.options)
    }
    module.hot.accept("./adminList.vue?vue&type=template&id=1ff33520", function () {
      api.rerender('1ff33520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/province/adminList.vue"
export default component.exports